import { DialogContent, styled } from "@mui/material"

export const SecurityDialogContainer = styled(DialogContent)(({ theme }) => ({
  padding: `0px ${theme.spacing(9)}`,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(3),
}))
